import React from 'react';
import {Helmet, HelmetProvider} from 'react-helmet-async';
import IndexSectionNavigations3 from '../components/navigations/IndexSectionNavigations3';
import IndexSectionApplication2 from '../components/application/IndexSectionApplication2';
import IndexSectionFeatures6 from '../components/features/IndexSectionFeatures6';
import IndexSectionApplication7 from '../components/application/IndexSectionApplication7';
import IndexSectionCallToAction10 from '../components/call-to-action/IndexSectionCallToAction10';
import IndexSectionApplication11 from '../components/application/IndexSectionApplication11';
import IndexSectionCallToAction12 from '../components/call-to-action/IndexSectionCallToAction12';
import IndexSectionApplication13 from '../components/application/IndexSectionApplication13';
import IndexSectionContact8 from '../components/contact/IndexSectionContact8';
import IndexSectionFooter4 from '../components/footer/IndexSectionFooter4';
import IndexSectionCallToAction15 from "../components/call-to-action/IndexSectionCallToAction15";
import CookieBanner from "../components/cookie-banner";

const meta = {
    title: 'FindAMeal - Discover Nearby Restaurants - AI-Powered Search Engine',
    meta: [],
    link: [],
    style: [],
    script: [],
    charSet: 'utf-8',
    description:
        'Restaurants near you. Find best restaurant, food places, to at ... Search with reviews from Yelp, Google, and more',
    keywords:
        'place to eat near me, restaurants to eat near me, food places to eat near me, best restaurants near me, best restaurant, eat, Restaurants, Find, place to eat, AI tool to find food, eat out, AI, engine, AI-Powered Restaurant search engine, restaurant, effortlessly',
};


export default function Index() {
    return (
        <React.Fragment>
            <HelmetProvider>
                <Helmet {...meta}>
                    <script
                        src="https://getlaunchlist.com/js/widget.js"
                        type="text/javascript"
                        defer
                    />
                    <script
                        defer
                        src='https://www.googletagmanager.com/gtag/js?id=G-R9BH7JXNWZ'
                    />
                    <script
                        id='google-analytics'
                        defer
                        dangerouslySetInnerHTML={{
                            __html: `
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());

              gtag('consent', 'default', {
                  'analytics_storage': 'denied'
              });
              
              gtag('config', 'G-R9BH7JXNWZ', {
                  page_path: window.location.pathname,
              });
              `
                        }}
                    />
                </Helmet>
            </HelmetProvider>
            <IndexSectionNavigations3/>
            <IndexSectionApplication2/>
            <IndexSectionFeatures6/>
            <IndexSectionApplication7/>
            <IndexSectionCallToAction10/>
            <IndexSectionApplication11/>
            <IndexSectionCallToAction12/>
            <IndexSectionApplication13/>
            <IndexSectionCallToAction15/>
            <IndexSectionContact8/>
            <IndexSectionFooter4/>
            <CookieBanner/>
        </React.Fragment>
    );
}

